// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@awc/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { mergeWithCss, xScreen } from "@awc/XDL/Utilities";
import { rfqRequestQuotePageContainerStyles } from "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuotePageContainer";
import { css } from "styled-components";

rfqRequestQuotePageContainerStyles.container = mergeWithCss(rfqRequestQuotePageContainerStyles.container, {
    css: css`
        ${xScreen("gt", "xs")} {
            grid-template-columns: minmax(0, 1fr);
            -ms-grid-columns: minmax(0, 1fr);
        }

        ${xScreen("gte", "md")} {
            grid-template-columns: 1fr 234px;
            -ms-grid-columns: minmax(0, 1fr) minmax(0, 1fr);
            grid-template-rows: repeat(5, auto);
            -ms-grid-rows: auto auto auto auto auto;
        }

        ${xScreen("gt", "lg")} {
            grid-template-columns: minmax(0, 3fr) minmax(0, 1fr);
            -ms-grid-columns: minmax(0, 3fr) minmax(0, 1fr);
        }
    `,
});

rfqRequestQuotePageContainerStyles.specificationsContainer = mergeWithCss(
    rfqRequestQuotePageContainerStyles.specificationsContainer,
    {
        css: css`
            padding-top: 35px;
            ${xScreen("lte", "sm")} {
                padding-top: 0;
                max-width: 450px;
            }
            ${xScreen("gt", "xs")} {
                border: 0 solid transparent;
                border-width: 0 1.5rem 20px 0;
            }
        `,
    },
);

rfqRequestQuotePageContainerStyles.emptyQuoteText = {
    ...dataTableStyles.noResultsText,
};
